import { T } from '@agos/shared'

import { selfAmendedNote, type AttendanceRecord } from './time-sheet'

/**
 * *upravené zamestnancom* - a day its owner corrected from the sidebar, FRONTEND.md §9.760, BACKEND.md §10A.414.
 *
 * Arrival and departure are what the wage sheet pays from (§9.557), so a correction somebody makes to their own hours
 * is the one change on this screen that a person other than its author has a reason to see. The mark says it
 * happened; its tooltip says when, and that the times before it are in the audit log, because this screen shows only
 * the times as they are now.
 *
 * Nothing at all for a day nobody corrected, so a row reads exactly as it did before §9.760.
 */
export function SelfAmendedMark({ record }: { record: AttendanceRecord | null }) {
  const note = selfAmendedNote(record)
  if (note === null) return null
  return (
    <span
      data-self-amended
      title={note}
      className="ml-1.5 shrink-0 whitespace-nowrap text-[10px] font-semibold text-amber-500"
    >
      <T>upravené zamestnancom</T>
    </span>
  )
}
